/**
 * @ngdoc Directive
 * @name vrm-hr
 * @example
 *
 * <vrm-hr ng-model="help" ng-value="true" />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmStatus', vrmStatus);

    /* @ngInject */
    function vrmStatus($log, moment, $interval, $rootScope, REALTIME_INDICATOR) {

        var definition = {
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/status/status.template.html'),
            link: link,
            transclude: true,
            scope: {
                time: '=',
                realtime: '=',
                timezone: '=',
                offset: '=',
                alarm: '=',
                openDevicesDrawer: '=',
                enabledOpenControlsButton: '=',
                controlDevicesDrawerOpen: '=',
                hasDeviceControls: '=',
                favorite: '=',
                onFavoriteChange: '=',
                showFavorite: '=',
            },
        };

        return definition;

        function link($scope) {
            $scope.controlsHovered = false;
            $scope.REALTIME_INDICATOR = REALTIME_INDICATOR;

            $scope.onControlsEnter = function () {
                $scope.controlsHovered = true;
            };

            $scope.$watch('controlDevicesDrawerOpen', function () {
                if ($scope.controlDevicesDrawerOpen) {
                    $scope.controlsHovered = false;
                }
            })

            $scope.onControlsLeave = function () {
                $scope.controlsHovered = false;
            };

            var intervalPromise;

            const updateDatetime = () => {
                $scope.datetime = Date.now();

                if (intervalPromise) {
                    $interval.cancel(intervalPromise);
                }

                intervalPromise = $interval(function() {
                    $scope.datetime = Date.now();
                }, 10000);
            };
            updateDatetime();

            var pageVisibilityRootScope = $rootScope.$on(
                "page-visibility-change",
                function(_, isVisible) {
                    if (isVisible) {
                        updateDatetime();
                    } else {
                        if (intervalPromise) {
                            $interval.cancel(intervalPromise);
                        }
                    }
                }
            );

            $scope.$on("$destroy", function() {
                if (intervalPromise) {
                    $interval.cancel(intervalPromise);
                }
                // Deregister the listeners on rootScope when this scope is destroyed
                pageVisibilityRootScope();
            });
        }
    }
})();
